import React, { useState, useEffect } from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const BetHistoryModal = ({ show, onClose, userPhone, historyData = [], casinoHistoryData = [] }) => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredSportsData, setFilteredSportsData] = useState([]);
  const [filteredCasinoData, setFilteredCasinoData] = useState([]);

  useEffect(() => {
    const filterData = () => {
      let filteredSports = [...historyData];
      let filteredCasino = [...casinoHistoryData];

      if (fromDate && toDate) {
        const from = new Date(fromDate);
        const to = new Date(toDate);
        to.setHours(23, 59, 59);

        filteredSports = filteredSports.filter((item) => {
          const itemDate = new Date(item.time);
          return !isNaN(itemDate) && itemDate >= from && itemDate <= to;
        });

        filteredCasino = filteredCasino.filter((item) => {
          const itemDate = new Date(item.time);
          return !isNaN(itemDate) && itemDate >= from && itemDate <= to;
        });
      }

      if (searchTerm) {
        const term = searchTerm.toLowerCase();
        filteredSports = filteredSports.filter((item) =>
          Object.values(item).some((val) =>
            String(val).toLowerCase().includes(term)
          )
        );
        filteredCasino = filteredCasino.filter((item) =>
          Object.values(item).some((val) =>
            String(val).toLowerCase().includes(term)
          )
        );
      }

      setFilteredSportsData(filteredSports);
      setFilteredCasinoData(filteredCasino);
    };

    filterData();
  }, [fromDate, toDate, searchTerm, historyData, casinoHistoryData]);

  const handleReset = () => {
    setFromDate("");
    setToDate("");
    setSearchTerm("");
    setFilteredSportsData(historyData);
    setFilteredCasinoData(casinoHistoryData);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();

    doc.setFontSize(18);
    doc.text(`Bet History - ${userPhone}`, 14, 15);
    doc.setFontSize(10);
    doc.text(`Downloaded: ${new Date().toLocaleString()}`, 14, 22);

    // Sports Table
    doc.setFontSize(12);
    doc.text("Sports Bet History", 14, 30);

    const sportsHeaders = [
      ["#", "Phone", "Competition", "Event", "Team", "Type", "Side", "Price", "Amount", "Profit", "Status", "Payment Status", "Time"],
    ];
    const sportsData = filteredSportsData.map((item, index) => [
      index + 1,
      item.phone,
      item.competitionName,
      item.eventName,
      item.runnerName,
      item.type,
      item.side,
      item.betprice,
      item.betAmount,
      item.profit,
      item.status === 1 ? "Won" : item.status === 2 ? "Lost" : item.status === 3 ? "Pending" : String(item.status),
      item.process_status === 1 ? "Completed" : item.status === 2 ? "Lost" : "Pending",
      new Date(item.time).toLocaleString(),
    ]);
    autoTable(doc, {
      head: sportsHeaders,
      body: sportsData,
      startY: 35,
      styles: { fontSize: 7 },
    });

    // Casino Table
    let casinoStartY = doc.lastAutoTable.finalY + 10;
    doc.setFontSize(12);
    doc.text("Casino Bet History", 14, casinoStartY);

    const casinoHeaders = [["#", "Phone", "Game", "Bet Amount", "Win Amount", "Status", "Time"]];
    const casinoData = filteredCasinoData.map((item, index) => [
      index + 1,
      item.playerId,
      item.gameCategory,
      item.amount,
      item.profit,
      item.status,
      new Date(item.time).toLocaleString(),
    ]);
    autoTable(doc, {
      head: casinoHeaders,
      body: casinoData,
      startY: casinoStartY + 5,
      styles: { fontSize: 7 },
    });

    doc.save(`Bet_History_${userPhone}.pdf`);
  };

  if (!show) return null;

  const statusBadge = (value) => {
    let color = "secondary";
    if (value === "Won" || value === 1 || value === "Win") color = "success";
    else if (value === "Lost" || value === 2 || value === "Loss") color = "danger";
    else if (value === "Pending" || value === 3) color = "warning";
    else if (value === "Completed") color = "info";
    return <span className={`badge bg-${color}`}>{String(value)}</span>;
  };

  return (
    <div className="modal show fade d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.6)" }}>
      <div className="modal-dialog modal-xl modal-dialog-scrollable" style={{ maxWidth: "95vw", overflowX: "hidden" }}>
        <div className="modal-content rounded-4 shadow-lg" style={{ overflowX: "hidden" }}>
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">Bet History – {userPhone}</h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>

          <div className="modal-body">
            {/* Filters */}
            <div className="row gy-3 gx-2 mb-4">
              <div className="col-md-3">
                <label className="form-label fw-semibold">From Date</label>
                <input type="date" className="form-control" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
              </div>
              <div className="col-md-3">
                <label className="form-label fw-semibold">To Date</label>
                <input type="date" className="form-control" value={toDate} onChange={(e) => setToDate(e.target.value)} />
              </div>
              <div className="col-md-4">
                <label className="form-label fw-semibold">Search</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by team, event, status..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="col-md-2 d-grid align-self-end">
                <button className="btn btn-outline-secondary" onClick={handleReset}>
                  Reset
                </button>
              </div>
            </div>

            <div className="mb-3 text-end">
              <button className="btn btn-outline-primary" onClick={handleDownloadPDF}>
                📄 Download PDF
              </button>
            </div>

            {/* Sports Table */}
            <h5>Sports Bet History</h5>
            <div className="table-responsive mb-4" style={{ maxHeight: "500px", overflowX: "auto" }}>
              <table className="table table-hover table-bordered text-center align-middle table-sm">
                <thead className="table-primary position-sticky top-0 z-2">
                  <tr>
                    <th>#</th>
                    <th>Phone</th>
                    <th>Competition</th>
                    <th>Event</th>
                    <th>Team</th>
                    <th>Type</th>
                    <th>Side</th>
                    <th>Price</th>
                    <th>Amount</th>
                    <th>Profit</th>
                    <th>Status</th>
                    <th>Settlement</th>
                    <th>Process</th>
                    <th>Time</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredSportsData.length > 0 ? (
                    filteredSportsData.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.phone}</td>
                        <td>{item.competitionName}</td>
                        <td>{item.eventName}</td>
                        <td>{item.runnerName}</td>
                        <td>{item.type}</td>
                        <td>{item.side}</td>
                        <td>{item.betprice}</td>
                        <td>{item.betAmount}</td>
                        <td>{item.profit}</td>
                        <td>{statusBadge(item.status)}</td>
                        <td>{statusBadge(item.settlementStatus)}</td>
                        <td>{statusBadge(item.process_status)}</td>
                        <td>{new Date(item.time).toLocaleString()}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="14" className="text-muted">
                        No sports records found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Casino Table */}
            <h5 className="mt-4">Casino Bet History</h5>
            <div className="table-responsive" style={{ maxHeight: "500px", overflowX: "auto" }}>
              <table className="table table-hover table-bordered text-center align-middle table-sm">
                <thead className="table-warning position-sticky top-0 z-2">
                  <tr>
                    <th>#</th>
                    <th>Phone</th>
                    <th>Game</th>
                    <th>Bet Amount</th>
                    <th>Win Amount</th>
                    <th>Status</th>
                    <th>Time</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCasinoData.length > 0 ? (
                    filteredCasinoData.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.playerId}</td>
                        <td>{item.gameName}</td>
                        <td>{item.amount}</td>
                        <td>{item.status === 1 ? item.profit : item.amount}</td>
                        <td>{statusBadge(item.status)}</td>
                        <td>{item.time}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-muted">
                        No casino records found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="modal-footer justify-content-between">
            <span className="text-muted small">
              Showing {filteredSportsData.length + filteredCasinoData.length}{" "}
              {(filteredSportsData.length + filteredCasinoData.length) === 1 ? "entry" : "entries"}
            </span>
            <button className="btn btn-danger" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BetHistoryModal;